import { Theme } from '@mui/material'

const useStyles = {
  stickyBanner: {
    flexShrink: 0,
  },
  outerContainer: {
    flex: 1,
    minHeight: 0,
    flexDirection: 'column',
    justifyContent: 'flex-start',
  },
  selectionContainer: {
    flex: 1,
    minHeight: 0,
    overflowY: 'auto',
    padding: '16px',
    flexDirection: 'column',
  },
  selectionRow: {
    paddingY: '8px',
    marginTop: '16px',
    gap: '8px',
    alignItems: 'center',
  },
  checkboxLabel: {
    flexDirection: 'column',
    paddingRight: '4px',
  },
  checkboxAddressRow: {
    alignItems: 'center',
  },
  bulkCheckboxButton: (theme: Theme) => ({
    textTransform: 'none',
    minWidth: 'unset',
    padding: 0,
    paddingX: theme.spacing(1),
  }),
  submitButton: {
    width: '200px',
  },
  locationIcon: {
    fontSize: '16px',
  },
  checkboxContainer: (theme: Theme) => ({
    padding: 0,
    margin: 0,
    paddingTop: '12px',
    paddingBottom: '16px',
    borderBottom: `1px solid ${theme.palette.divider}`,
    width: '100%',
    justifyContent: 'space-between',
    marginLeft: 0,
  }),
  footer: (theme: Theme) => ({
    flexShrink: 0,
    width: '100%',
    minHeight: '104px',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme.palette.background.paper,
    boxShadow: '0 4px 8px 3px rgba(0, 0, 0, 0.15), 0 1px 3px 0 rgba(0, 0, 0, 0.30)',
  }),
}

export default useStyles
